import { PageId } from 'constants/pages'

export const enum PageIdWoofzVc6 {
  SEX_VC6 = PageId.SEX_VC6,
  DOG_AGE_VC6 = PageId.DOG_AGE_VC6,
  SHELTER_VC6 = PageId.SHELTER_VC6,
  DOG_BREED_VC6 = PageId.DOG_BREED_VC6,
  BEHAVIOR_VC6 = PageId.BEHAVIOR_VC6,
  HEALTH_ISSUES_VC6 = PageId.HEALTH_ISSUES_VC6,
  GOALS_QUESTION_VC6 = PageId.GOALS_QUESTION_VC6,
  URGE_VC6 = PageId.URGE_VC6,
  FEED_VC6 = PageId.FEED_VC6,
  WALK_VC6 = PageId.WALK_VC6,
  STRESS_VC6 = PageId.STRESS_VC6,
  HOME_ALONG_VC6 = PageId.HOME_ALONG_VC6,
  ACTIVITY_VC6 = PageId.ACTIVITY_VC6,
  DESCRIBE_VC6 = PageId.DESCRIBE_VC6,
  ALMOST_DONE_VC6 = PageId.ALMOST_DONE_VC6,
  TRAINER_IS_READY_VC6 = PageId.TRAINER_IS_READY_VC6,
  DOG_SUMMARY_VC6 = PageId.DOG_SUMMARY_VC6,
  FEATURE_DESCRIPTION_VC6 = PageId.FEATURE_DESCRIPTION_VC6,
  CYNOLOGISTS_VC6 = PageId.CYNOLOGISTS_VC6,
  OUR_MISSION_VC6 = PageId.OUR_MISSION_VC6,
  LIMITED_OFFER_VC6 = PageId.LIMITED_OFFER_VC6,
  SUBSCRIPTIONS_TRIAL_PRICE_VC6 = PageId.SUBSCRIPTIONS_TRIAL_PRICE_VC6,
  SUBSCRIPTIONS_TRIAL_PRICE_2_VC6 = PageId.SUBSCRIPTIONS_TRIAL_PRICE_2_VC6,
  CALENDLY_VC6 = PageId.CALENDLY_VC6,
  ALL_SET_VC6 = PageId.ALL_SET_VC6,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
}
